import { render, staticRenderFns } from "./BasicInfoModal.vue?vue&type=template&id=3e0600de&scoped=true"
import script from "./BasicInfoModal.vue?vue&type=script&lang=js"
export * from "./BasicInfoModal.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoModal.vue?vue&type=style&index=0&id=3e0600de&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0600de",
  null
  
)

export default component.exports